/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkOrderBoardTicketDto
 */
export interface WorkOrderBoardTicketDto {
    /**
     * 
     * @type {string}
     * @memberof WorkOrderBoardTicketDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderBoardTicketDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderBoardTicketDto
     */
    type: WorkOrderBoardTicketDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderBoardTicketDto
     */
    status: WorkOrderBoardTicketDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof WorkOrderBoardTicketDto
     */
    needsFollowUp: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderBoardTicketDto
     */
    priority: WorkOrderBoardTicketDtoPriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderBoardTicketDto
     */
    title: string;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderBoardTicketDto
     */
    assetId?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderBoardTicketDto
     */
    siteId?: object | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkOrderBoardTicketDto
     */
    dueAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderBoardTicketDto
     */
    membershipId: string;
    /**
     * 
     * @type {number}
     * @memberof WorkOrderBoardTicketDto
     */
    executionNumber: number;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderBoardTicketDto
     */
    membershipStatus: WorkOrderBoardTicketDtoMembershipStatusEnum;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderBoardTicketDto
     */
    taskId?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderBoardTicketDto
     */
    preventivePlanId?: object | null;
    /**
     * Preventive plan business code that generated this ticket
     * @type {object}
     * @memberof WorkOrderBoardTicketDto
     */
    planCode?: object | null;
    /**
     * Preventive plan display name
     * @type {object}
     * @memberof WorkOrderBoardTicketDto
     */
    planName?: object | null;
    /**
     * Concerned asset display name
     * @type {object}
     * @memberof WorkOrderBoardTicketDto
     */
    assetName?: object | null;
    /**
     * Concerned asset serial number
     * @type {object}
     * @memberof WorkOrderBoardTicketDto
     */
    assetSerialNumber?: object | null;
    /**
     * Latest visit execution result for Kanban chips (lean board — no report body)
     * @type {string}
     * @memberof WorkOrderBoardTicketDto
     */
    lastExecutionResult?: WorkOrderBoardTicketDtoLastExecutionResultEnum | null;
    /**
     * Linked incident for curative (corrective) tickets
     * @type {object}
     * @memberof WorkOrderBoardTicketDto
     */
    incidentId?: object | null;
    /**
     * Linked incident business code
     * @type {object}
     * @memberof WorkOrderBoardTicketDto
     */
    incidentCode?: object | null;
    /**
     * Linked incident title
     * @type {object}
     * @memberof WorkOrderBoardTicketDto
     */
    incidentTitle?: object | null;
}


/**
 * @export
 */
export const WorkOrderBoardTicketDtoTypeEnum = {
    Preventive: 'PREVENTIVE',
    Curative: 'CURATIVE'
} as const;
export type WorkOrderBoardTicketDtoTypeEnum = typeof WorkOrderBoardTicketDtoTypeEnum[keyof typeof WorkOrderBoardTicketDtoTypeEnum];

/**
 * @export
 */
export const WorkOrderBoardTicketDtoStatusEnum = {
    Open: 'OPEN',
    InProgress: 'IN_PROGRESS',
    Closed: 'CLOSED',
    Cancelled: 'CANCELLED'
} as const;
export type WorkOrderBoardTicketDtoStatusEnum = typeof WorkOrderBoardTicketDtoStatusEnum[keyof typeof WorkOrderBoardTicketDtoStatusEnum];

/**
 * @export
 */
export const WorkOrderBoardTicketDtoPriorityEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;
export type WorkOrderBoardTicketDtoPriorityEnum = typeof WorkOrderBoardTicketDtoPriorityEnum[keyof typeof WorkOrderBoardTicketDtoPriorityEnum];

/**
 * @export
 */
export const WorkOrderBoardTicketDtoMembershipStatusEnum = {
    Active: 'ACTIVE',
    MovedOut: 'MOVED_OUT',
    Cancelled: 'CANCELLED'
} as const;
export type WorkOrderBoardTicketDtoMembershipStatusEnum = typeof WorkOrderBoardTicketDtoMembershipStatusEnum[keyof typeof WorkOrderBoardTicketDtoMembershipStatusEnum];

/**
 * @export
 */
export const WorkOrderBoardTicketDtoLastExecutionResultEnum = {
    CompletedOk: 'COMPLETED_OK',
    CompletedWithIssue: 'COMPLETED_WITH_ISSUE',
    NotDone: 'NOT_DONE',
    Cancelled: 'CANCELLED'
} as const;
export type WorkOrderBoardTicketDtoLastExecutionResultEnum = typeof WorkOrderBoardTicketDtoLastExecutionResultEnum[keyof typeof WorkOrderBoardTicketDtoLastExecutionResultEnum];


/**
 * Check if a given object implements the WorkOrderBoardTicketDto interface.
 */
export function instanceOfWorkOrderBoardTicketDto(value: object): value is WorkOrderBoardTicketDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('needsFollowUp' in value) || value['needsFollowUp'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('membershipId' in value) || value['membershipId'] === undefined) return false;
    if (!('executionNumber' in value) || value['executionNumber'] === undefined) return false;
    if (!('membershipStatus' in value) || value['membershipStatus'] === undefined) return false;
    return true;
}

export function WorkOrderBoardTicketDtoFromJSON(json: any): WorkOrderBoardTicketDto {
    return WorkOrderBoardTicketDtoFromJSONTyped(json, false);
}

export function WorkOrderBoardTicketDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkOrderBoardTicketDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'type': json['type'],
        'status': json['status'],
        'needsFollowUp': json['needsFollowUp'],
        'priority': json['priority'],
        'title': json['title'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'dueAt': json['dueAt'] == null ? undefined : (new Date(json['dueAt'])),
        'membershipId': json['membershipId'],
        'executionNumber': json['executionNumber'],
        'membershipStatus': json['membershipStatus'],
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'preventivePlanId': json['preventivePlanId'] == null ? undefined : json['preventivePlanId'],
        'planCode': json['planCode'] == null ? undefined : json['planCode'],
        'planName': json['planName'] == null ? undefined : json['planName'],
        'assetName': json['assetName'] == null ? undefined : json['assetName'],
        'assetSerialNumber': json['assetSerialNumber'] == null ? undefined : json['assetSerialNumber'],
        'lastExecutionResult': json['lastExecutionResult'] == null ? undefined : json['lastExecutionResult'],
        'incidentId': json['incidentId'] == null ? undefined : json['incidentId'],
        'incidentCode': json['incidentCode'] == null ? undefined : json['incidentCode'],
        'incidentTitle': json['incidentTitle'] == null ? undefined : json['incidentTitle'],
    };
}

export function WorkOrderBoardTicketDtoToJSON(json: any): WorkOrderBoardTicketDto {
    return WorkOrderBoardTicketDtoToJSONTyped(json, false);
}

export function WorkOrderBoardTicketDtoToJSONTyped(value?: WorkOrderBoardTicketDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'type': value['type'],
        'status': value['status'],
        'needsFollowUp': value['needsFollowUp'],
        'priority': value['priority'],
        'title': value['title'],
        'assetId': value['assetId'],
        'siteId': value['siteId'],
        'dueAt': value['dueAt'] == null ? value['dueAt'] : value['dueAt'].toISOString(),
        'membershipId': value['membershipId'],
        'executionNumber': value['executionNumber'],
        'membershipStatus': value['membershipStatus'],
        'taskId': value['taskId'],
        'preventivePlanId': value['preventivePlanId'],
        'planCode': value['planCode'],
        'planName': value['planName'],
        'assetName': value['assetName'],
        'assetSerialNumber': value['assetSerialNumber'],
        'lastExecutionResult': value['lastExecutionResult'],
        'incidentId': value['incidentId'],
        'incidentCode': value['incidentCode'],
        'incidentTitle': value['incidentTitle'],
    };
}

